export const remove1FormEndOfSymbolName = (symbolName: string): string =>
	symbolName.slice(-1) === '1'
		? // && isNaN(+symbolName.slice(-2)) ?
			symbolName.slice(0, -1)
		: symbolName;
export const normalizeTitle = (symbolTitle: string): string => {
	let searchOptimizeTitle: string = symbolTitle; // remove all spaces
	searchOptimizeTitle = searchOptimizeTitle.replace(/ /g, ''); // remove all spaces
	searchOptimizeTitle = searchOptimizeTitle.replace(/‌/g, ''); // remove all half spaces
	searchOptimizeTitle = searchOptimizeTitle.replace(/آ/g, 'ا'); // remove all آ
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ي', 'g'), 'ی'); // جایگزینی ي عربی با ی فارسی
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ك', 'g'), 'ک'); // جایگزینی ك عربی با ک فارسی

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ط', 'g'), 'ت'); // جایگزینی ط عربی با ت

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ه', 'g'), 'ح'); // جایگزینی ه عربی با ح

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ذ', 'g'), 'ز'); // جایگزینی ذ عربی با ز
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ظ', 'g'), 'ز'); // جایگزینی ظ عربی با ز
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ض', 'g'), 'ز'); // جایگزینی ض عربی با ز

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ص', 'g'), 'س'); // جایگزینی ص عربی با س
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ث', 'g'), 'س'); // جایگزینی ث عربی با س

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('غ', 'g'), 'ق'); // جایگزینی غ عربی با ق

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ء', 'g'), 'ع'); // جایگزینی ء عربی با ع
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ئ', 'g'), 'ع'); // جایگزینی ئ عربی با ع

	return searchOptimizeTitle;
};

export const normalizeTitleKeepSpace = (symbolTitle: string): string => {
	let searchOptimizeTitle: string = symbolTitle; // remove all spaces
	searchOptimizeTitle = searchOptimizeTitle.replace(/آ/g, 'ا'); // remove all آ
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ي', 'g'), 'ی'); // جایگزینی ي عربی با ی فارسی
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ك', 'g'), 'ک'); // جایگزینی ك عربی با ک فارسی

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ط', 'g'), 'ت'); // جایگزینی ط عربی با ت

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ه', 'g'), 'ح'); // جایگزینی ه عربی با ح

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ذ', 'g'), 'ز'); // جایگزینی ذ عربی با ز
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ظ', 'g'), 'ز'); // جایگزینی ظ عربی با ز
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ض', 'g'), 'ز'); // جایگزینی ض عربی با ز

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ص', 'g'), 'س'); // جایگزینی ص عربی با س
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ث', 'g'), 'س'); // جایگزینی ث عربی با س

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('غ', 'g'), 'ق'); // جایگزینی غ عربی با ق

	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ء', 'g'), 'ع'); // جایگزینی ء عربی با ع
	searchOptimizeTitle = searchOptimizeTitle.replace(new RegExp('ئ', 'g'), 'ع'); // جایگزینی ئ عربی با ع

	return searchOptimizeTitle;
};
